import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getLanguageWithCountry } from "src/utils/BasePathTools";

export const UpdateLanguage: React.FC = () => {  const location = useLocation();
  useEffect(() => {
    const langWithCountry = getLanguageWithCountry();
    document.documentElement.lang = langWithCountry;
  }, [location]);

  return null;
};
